const locale = {
  layout_list_result: '{total} 条结果',
  layout_list_selectedTotal: '( {selectedTotal} 条选中 )',
  layout_basic_header_howTo: '操作指南',
  layout_basic_header_whatIs: '是什么？'
};
export default locale;